var module = angular.module('octopusApp.projects');

module.directive('volumesFrom', function($timeout, octopusLog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_run/volumes-from.html',
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        link: function($scope, $element) {
            //$scope.$element = $element;
        },
        controller: function() {
            var vm = this;

            vm.newContainer = "";
            vm.editContainer = "";
            vm.addContainer = addContainer;
            vm.cancelEdit = cancelEdit;
            vm.commitEdit = commitEdit;
            vm.remove = remove;
            vm.containers = [];
            vm.isEditing = false;

            function addContainer() {
                if (vm.containers.indexOf(vm.newContainer) !== -1) {
                    octopusLog.log("Mapping to that container port already exists.. Try again");
                    return;
                }

                vm.containers.push({name: vm.newContainer, editName:  vm.newContainer});
                setOnProperties();
                vm.newContainer = "";
                vm.editContainer = "";
            }

            function commitEdit(container) {
                container.isEditing = false;
                container.name = container.editName;
                setOnProperties();
            }

            function remove(container) {
                var idx = vm.containers.indexOf(container);

                if (idx >= 0) {
                    vm.containers.splice(idx, 1);
                }
                setOnProperties();
            }

            function setOnProperties() {
                vm.action.Properties["Octopus.Action.Docker.VolumesFrom"] = vm.containers.map(function(c){ return c.name; }).join(',');
            }

            function cancelEdit(container) {
                container.isEditing = false;
                container.editName = container.name;
            }

            function init() {
                var volumesFrom = vm.action.Properties["Octopus.Action.Docker.VolumesFrom"] || '';
                vm.containers = volumesFrom.split(',')
                    .map(function(v){ return v.trim(); })
                    .filter(function(v) { return !!v && v !== '';})
                    .map(function(v) {
                        return {name: v, editName: v};
                    });
            }

            init();
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/volumes-from.js
// module id = 7100885490210703
// module chunks = 1